
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 384 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m336 0h-288c-26.51 0-48 21.49-48 48v464l192-112 192 112v-464c0-26.51-21.49-48-48-48zm16 456.287-160-93.333-160 93.333v-408.287c0-8.822 7.178-16 16-16h288c8.822 0 16 7.178 16 16z"}})])
          )
        }
      }
    